// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"366":"d77beaa1","455":"b22f2b80","664":"03459e1b","866":"1a4d58c5","885":"d384ebb3"}[chunkId] + ".chunk.css";
};